import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import CourseButton from '#components/m/Wissensportal/CourseButton'
import {Modules} from '#components/m/Wissensportal/Modules'

export function Courses({courses, selectedCourseId, onCourseClick, mode, modules}) {
  function isSelected(course) {
    return selectedCourseId === course.id
  }
  const isVertical = mode === 'vertical'
  return (
    <div className="courses__wrapper">
      {courses.length > 0 ? (
        courses.map(course => {
          const isActive = isSelected(course)
          const filteredModules = modules ? modulesFromCourse(modules, course.id) : []
          return (
            <div key={course.id.toString()} className="courses__wrapper-course" data-testid="course">
              <CourseButton
                course={{...course, isActive}}
                isVertical={isVertical}
                handleClick={onCourseClick}
                key={course.id}
                disabled={modules !== undefined}
              />
              {isVertical && selectedCourseId && course.id === selectedCourseId && <Modules modules={course.modules} />}
              {filteredModules.length > 0 && <Modules modules={filteredModules} modifier="uncollapsible" />}
            </div>
          )
        })
      ) : (
        <div className="no_course_result">
          <span>{i18n.t('wissensportal_no_filtered_courses')}</span>
        </div>
      )}
    </div>
  )
}

const modulesFromCourse = (modules, courseId) => modules.filter(m => m.courseId === courseId)
Courses.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      status: PropTypes.oneOf(['NOT_STARTED', 'IN_PROGRESS', 'FINISHED']),
    }),
  ),
  modules: PropTypes.array,
  selectedCourseId: PropTypes.number,
  onCourseClick: PropTypes.func,
  mode: PropTypes.oneOf(['default', 'vertical']),
}
